import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";

function Pais(props) {
  const { history } = props;
  const [PaisStateUpdate, setPaisStateUpdate] = useState([]);
  const [PaisState, setPaisState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setusuario] = useState(CurrentUser.user);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [update, setUpdate] = useState(false);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "countries/?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setPaisState(JSON.parse(responseJsonUpdate));
        setPaisStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, usuario, history]);
  const [formularioState, setFormularioState] = useState({
    isocode2: "",
    isocode3: "",
    name: "",
    alias: "",
    numcode: "",
    phonecode: "",
  });

  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };
  let crearPais = async (event) => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      event.preventDefault();
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(Parametros.post + "countries", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert("ok");
          setUpdate(!update);
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setUpdate(!update);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };
  // let eliminarElemento = async (index, item) => {
  //
  //   // setetapaStateUpdate(nuevoObjeto)
  //   if (usuario.permisos.indexOf("Eliminar") > -1) {
  //     if (window.confirm('¿Esta seguro que deseas elminar este elemento?')) {
  //       // aqui deberia ir el delete segun response eliminar de la lista de react

  //
  //       let response = await fetch(Parametros.urlApi + "countries/" + item.country_id,
  //         {
  //           method: 'DELETE',
  //           headers: {
  //             'Authorization': "Bearer " + usuario.key,
  //             'Accept': 'application/json',
  //             'Content-Type': 'application/json',
  //             'Origin': 'https://d1tl5p9wrfnj29.cloudfront.net/'
  //           },
  //         }

  //       )
  //       let responseJson = await response.json()
  //

  //       if (response.status === 200) {
  //         alert(responseJson.detail)
  //         setUpdate(!update)
  //       } else if (response.status === Parametros.loginTokenExcept) {
  //         alert(Parametros.loginTokenExceptMessage)
  //         history.push({
  //           pathname: '/'
  //         })
  //       } else {
  //
  //         alert(JSON.stringify(responseJson.detail))
  //         setPaisState(JSON.parse(JSON.stringify(PaisState)))
  //         setEditable({})
  //       }
  //     } else {
  //       // Do nothing!
  //       // setEditable({})
  //       // setPaisState(JSON.parse(JSON.stringify(PaisStateUpdate)))
  //     }
  //   } else {
  //     alert(usuario.eliminar)
  //   }

  // }
  let PaisHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = PaisState;
    newList[index][name] = value;
    setPaisState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let confirmarEdicion = async (item) => {
    // setetapaStateUpdate(nuevoObjeto)
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(
          Parametros.urlApi + "countries/" + item.country_id,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(formularioUpdate),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert("ok");
          setEditable({});
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setPaisState(JSON.parse(JSON.stringify(PaisStateUpdate)));
          setEditable({});
        }
      } else {
        // Do nothing!
        setEditable({});
        setPaisState(JSON.parse(JSON.stringify(PaisStateUpdate)));
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setPaisState(JSON.parse(JSON.stringify(PaisStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let cancelarEdicion = async (item) => {
    setEditable({});
    setPaisState(JSON.parse(JSON.stringify(PaisStateUpdate)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"País"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearPais}>
          <div className="col-md-4">
            <h5>País</h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Código ISO 2</h5>
            <input
              onChange={handleStageForm}
              maxLength={"2"}
              name="isocode2"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Código ISO 3</h5>
            <input
              onChange={handleStageForm}
              maxLength={"3"}
              name="isocode3"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Alias</h5>
            <input
              onChange={handleStageForm}
              name="alias"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Código Numerico</h5>
            <input
              onChange={handleStageForm}
              name="numcode"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Código celular</h5>
            <input
              onChange={handleStageForm}
              name="phonecode"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(PaisState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={[
              "Nombre Pais",
              "Código ISO 2",
              "Código ISO 3",
              "Alias",
              "Código Numerico",
              "Código Telefonico",
            ]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              elementos={[
                "Nombre Pais",
                "Código ISO 2",
                "Código ISO 3",
                "Alias",
                "Código Numerico",
                "Código Telefonico",
              ]}
            ></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {PaisState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.country_id}>
                      {editable === item.country_id ? (
                        <>
                          <td>{item.country_id}</td>

                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                PaisHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.isocode2}
                              name="isocode2"
                              maxLength={"2"}
                              onChange={(event) => {
                                PaisHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.isocode3}
                              name="isocode3"
                              maxLength={"3"}
                              onChange={(event) => {
                                PaisHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.alias}
                              name="alias"
                              onChange={(event) => {
                                PaisHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.numcode}
                              name="numcode"
                              onChange={(event) => {
                                PaisHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <input
                              value={item.phonecode}
                              name="phonecode"
                              onChange={(event) => {
                                PaisHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>

                          <td>
                            <abbr title="Confirmar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.country_id}</td>
                          <td>{item.name} </td>
                          <td>{item.isocode2} </td>
                          <td>{item.isocode3} </td>
                          <td>{item.alias} </td>
                          <td>{item.numcode} </td>
                          <td>{item.phonecode} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.country_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            {/* <abbr title="Eliminar Elemento"><span style={{ cursor: "pointer" }} onClick={() => { eliminarElemento(index, item) }} className='glyphicon glyphicon-remove'></span></abbr> */}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(PaisState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Pais);
